import { BASE_URL } from "../configs";
import { getAccessToken } from "../helpers/auth/token";
import { getQueryParamsString } from "../lib/utils";
import axiosInstance from "./axios";

export async function getTask(taskId) {
  var headers = new Headers();
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");
  headers.set("Authorization", `Bearer ${getAccessToken()}`);

  let url = `${BASE_URL}/api/task/${taskId}`;

  const response = await fetch(url, {
    method: "get",
    headers,
    credentials: "include",
  });

  if (response.status > 400) {
    throw response;
  }

  const res = await response.json();
  return res.Data;
}

export async function getTasks({ q, page, perPage, projectId, assigneeId, startAt, endAt }) {
  let url = `${BASE_URL}/api/task?`;
  url += getQueryParamsString({ q, page, perPage, projectId, assigneeId, startAt, endAt })

  const res = await axiosInstance.get(url)
  return res.data.Data;
}

export async function getTasksForEquipments({ equipmentIds, startAt, endAt }) {
  var headers = new Headers();
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");
  headers.set("Authorization", `Bearer ${getAccessToken()}`);

  let url = `${BASE_URL}/api//task/equipment-tasks`;

  const response = await fetch(url, {
    method: "post",
    headers,
    body: JSON.stringify({ equipmentIds, startAt, endAt }),
    credentials: "include",
  });

  if (response.status > 400) {
    throw response;
  }

  const res = await response.json();
  return res.Data;
}

export async function createTask(project) {
  let url = `${BASE_URL}/api/task`;

  const res = await axiosInstance.post(url, project)
  return res.data.Data;
}

export async function updateTask(project) {
  let url = `${BASE_URL}/api/task`;

  const res = await axiosInstance.put(url, project)
  return res.data.Data;
}


export async function deleteTask(projectId) {
  let url = `${BASE_URL}/api/task/${projectId}`;

  const res = await axiosInstance.delete(url)
  return res.data.Data;
}
